import { ApiEndpointBuilder } from "@/services/api/types";
import { DataResponse } from "@/types/reponse-data.ts";
import { UserInvitation } from "@/types/user.ts";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";

const acceptInvitation = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, { invitationId: string | undefined }>({
    async queryFn(arg, _api, _extraOptions, baseQuery) {
      const invitationFilter = {
        logic: "and",
        filters: [
          {
            field: "id",
            operator: "eq",
            value: arg?.invitationId,
          },
        ],
      };
      const tenantRes = await baseQuery({
        url: "/invitations/search",
        method: "POST",
        body: { advancedFilter: invitationFilter },
      });

      if (tenantRes.error) {
        return { error: tenantRes.error };
      }

      const tenantId = (tenantRes.data as DataResponse<UserInvitation>)?.data[0]?.tenantId;

      if (!tenantId) {
        return { error: { status: 404, data: "Tenant not found" } };
      }

      return baseQuery({
        url: `/invitations/${arg.invitationId}/accept`,
        method: "PUT",
        headers: {
          "x-tenant": tenantId,
        },
      }) as Promise<QueryReturnValue<string, FetchBaseQueryError, FetchBaseQueryMeta>>;
    },
    invalidatesTags: [
      { type: "userInvitations", id: "LIST" },
      { type: "usersInvitationsList" },
    ],
  });
};

export default acceptInvitation;
